var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',[_c('span',{staticClass:"headline pa-2 mb-2 pageTitle"},[_vm._v(_vm._s(_vm.pageTitle))]),(_vm.detailID)?_c('span',{staticClass:"pa-2 mb-2 detail-id"},[_vm._v("[ No. "+_vm._s(_vm.detailID)+" ]")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }